<template>
  <!-- 开票 -->
  <Invoice />
</template>
<script>
export default {
  name: 'invoice'
}
</script>
